<div *ngIf="isLoading" class="ds-donut-card">
  <div class="ds-card-title"></div>
  <div class="ds-donut-wrapper">
    <div class="ds-donut-circle"></div>
  </div>
  <div class="ds-table">
    <div class="ds-table-row" *ngFor="let _ of [1,2,3,4,5]">
      <div class="ds-bar ds-bar--color"></div>
      <div class="ds-bar ds-bar--name"></div>
      <div class="ds-bar ds-bar--amount"></div>
    </div>
  </div>
</div>

<kodit-card-container *ngIf="!isLoading">
  <ng-container card-title>
    Top {{ N }} {{ nazivCard }}
    <i
      class="pi pi-info-circle info-icon"
      pTooltip="Ne računaju se otkazane, stornirane, poništene, odbijene i obrisane fakture."
      tooltipPosition="top"
    ></i>
  </ng-container>
  <ng-container
    card-subtitle
    *ngIf="
      topNStrankiDonutResponseList.length > 0 &&
      topNStrankiDonutResponseList.length < N
    "
    >Napomena: trenutno nema {{ N }} {{ nazivCard.toLowerCase() }}</ng-container
  >
  <div
    class="p-d-flex p-flex-column gap-25"
    card-body
    *ngIf="topNStrankiDonutResponseList.length > 0"
  >
    <div>
      <p-chart
        type="doughnut"
        [data]="chartData"
        [options]="chartOptions"
      ></p-chart>
    </div>
    <div>
      <kodit-top-n-stranki-table
        [data]="topNStrankiDonutResponseList"
        [naziv]="tabelaNaziv"
      ></kodit-top-n-stranki-table>
    </div>
  </div>

  <div
    class="p-d-flex"
    card-body
    *ngIf="topNStrankiDonutResponseList.length === 0"
  >
    <div class="p-text-left">Trenutno nema podataka...</div>
  </div>
</kodit-card-container>
